const transformArrayToObject = ({
  data,
  fieldAsKey,
  fieldAsValue,
}: {
  data: Record<string, any>[];
  fieldAsKey: string | string[];
  fieldAsValue?: string;
}) => {
  const fieldKeys = Array.isArray(fieldAsKey) ? fieldAsKey : [fieldAsKey];

  return data.reduce((prevStock, record) => {
    const recordUniqueKey = fieldKeys?.map(fieldKey => record[fieldKey])?.join('_');
    return {
      ...prevStock,
      [recordUniqueKey]: fieldAsValue ? record[fieldAsValue] : record,
    };
  }, {});
};

export default transformArrayToObject;
